// extracted by mini-css-extract-plugin
export default {"mainCont":"SupervisorOrderHistory_mainCont__D3iXG","TableDiv":"SupervisorOrderHistory_TableDiv__WRcE7"};